import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  PROFORMA_INVOICE_LIST,
  PROFORMA_INVOICE_LIST_SEARCH,
  PROFORMA_INVOICE_DATA,
  PROFORMA_INVOICE_CREATE,
  PROFORMA_INVOICE_UPDATE,
  PROFORMA_INVOICE_VOID,
  PROFORMA_INVOICE_ITEM_SEARCH,
  PROFORMA_INVOICE_ITEM_LIST,
  PROFORMA_INVOICE_STATUS_LIST,
  PROFORMA_INVOICE_STATUS_DATA,
  PROFORMA_INVOICE_STATUS_CREATE,
  PROFORMA_INVOICE_STATUS_UPDATE,
  PROFORMA_INVOICE_STATUS_DELETE,
  PROFORMA_INVOICE_PDF,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE,
  PROFORMA_INVOICE_SEARCH,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH,
} from "./actionType";

import {
  proformaInvoiceListSuccess,
  proformaInvoiceListFailure,
  proformaInvoiceDataSuccess,
  proformaInvoiceDataFailure,
  proformaInvoiceCreateSuccess,
  proformaInvoiceCreateFailure,
  proformaInvoiceUpdateSuccess,
  proformaInvoiceUpdateFailure,
  proformaInvoiceVoidSuccess,
  proformaInvoiceVoidFailure,
  proformaInvoiceItemListSuccess,
  proformaInvoiceItemListFailure,
  proformaInvoiceItemSearchSuccess,
  proformaInvoiceItemSearchFailure,
  proformaInvoiceStatusListSuccess,
  proformaInvoiceStatusListFailure,
  proformaInvoiceStatusDataSuccess,
  proformaInvoiceStatusDataFailure,
  proformaInvoiceStatusCreateSuccess,
  proformaInvoiceStatusCreateFailure,
  proformaInvoiceStatusUpdateSuccess,
  proformaInvoiceStatusUpdateFailure,
  proformaInvoiceStatusDeleteSuccess,
  proformaInvoiceStatusDeleteFailure,
  proformaInvoicePDFSuccess,
  proformaInvoicePDFFailure,
  proformaInvoiceEmailSendAutomatedSuccess,
  proformaInvoiceEmailSendAutomatedFailure,
  proformaInvoiceEmailResendAutomatedSuccess,
  proformaInvoiceEmailResendAutomatedFailure,
  proformaInvoiceConvertToInvoiceSuccess,
  proformaInvoiceConvertToInvoiceFailure,
  proformaInvoiceSearchSuccess,
  proformaInvoiceSearchFailure,
  proformaInvoiceActivityLogSearchSuccess,
  proformaInvoiceActivityLogSearchFailure,
} from "./action";

import {
  getProformaInvoiceListAPI,
  getProformaInvoiceDataAPI,
  createProformaInvoiceAPI,
  updateProformaInvoiceAPI,
  voidProformaInvoiceAPI,
  getProformaInvoiceItemListAPI,
  searchProformaInvoiceItemAPI,
  getProformaInvoiceStatusListAPI,
  getProformaInvoiceStatusDataAPI,
  createProformaInvoiceStatusAPI,
  updateProformaInvoiceStatusAPI,
  deleteProformaInvoiceStatusAPI,
  getProformaInvoicePDFAPI,
  sendAutomatedProformaInvoiceEmailAPI,
  resendAutomatedProformaInvoiceEmailAPI,
  convertProformaInvoiceToInvoiceAPI,
  searchProformaInvoiceAPI,
  getProformaInvoiceActivityLogAPI,
} from "../../helpers/fakebackend_helper";

// Proforma Invoice List
function* proformaInvoiceList() {
  try {
    const response = yield call(getProformaInvoiceListAPI);
    yield put(proformaInvoiceListSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceListFailure(error));
  }
}

function* watchProformaInvoiceList() {
  yield takeEvery(PROFORMA_INVOICE_LIST, proformaInvoiceList);
}

// Proforma Invoice List Search
function* proformaInvoiceListSearch({ payload }) {
  try {
    const response = yield call(getProformaInvoiceListAPI, payload);
    yield put(proformaInvoiceListSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceListFailure(error));
  }
}

function* watchProformaInvoiceListSearch() {
  yield takeEvery(PROFORMA_INVOICE_LIST_SEARCH, proformaInvoiceListSearch);
}

// Proforma Invoice Data
function* proformaInvoiceData({ payload }) {
  try {
    const response = yield call(getProformaInvoiceDataAPI, payload);
    yield put(proformaInvoiceDataSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceDataFailure(error));
  }
}

function* watchProformaInvoiceData() {
  yield takeEvery(PROFORMA_INVOICE_DATA, proformaInvoiceData);
}

// Proforma Invoice Create
function* proformaInvoiceCreate({ payload }) {
  try {
    const response = yield call(createProformaInvoiceAPI, payload);
    yield put(proformaInvoiceCreateSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceCreateFailure(error));
  }
}

function* watchProformaInvoiceCreate() {
  yield takeEvery(PROFORMA_INVOICE_CREATE, proformaInvoiceCreate);
}

// Proforma Invoice Update
function* proformaInvoiceUpdate({ payload }) {
  try {
    const response = yield call(updateProformaInvoiceAPI, payload);
    yield put(proformaInvoiceUpdateSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceUpdateFailure(error));
  }
}

function* watchProformaInvoiceUpdate() {
  yield takeEvery(PROFORMA_INVOICE_UPDATE, proformaInvoiceUpdate);
}

// Proforma Invoice Void
function* proformaInvoiceVoid({ payload }) {
  try {
    const response = yield call(voidProformaInvoiceAPI, payload);
    yield put(proformaInvoiceVoidSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceVoidFailure(error));
  }
}

function* watchProformaInvoiceVoid() {
  yield takeEvery(PROFORMA_INVOICE_VOID, proformaInvoiceVoid);
}

// Proforma Invoice Item List
function* proformaInvoiceItemList() {
  try {
    const response = yield call(getProformaInvoiceItemListAPI);
    yield put(proformaInvoiceItemListSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceItemListFailure(error));
  }
}

function* watchProformaInvoiceItemList() {
  yield takeEvery(PROFORMA_INVOICE_ITEM_LIST, proformaInvoiceItemList);
}

// Proforma Invoice Item Search
function* proformaInvoiceItemSearch({ payload }) {
  try {
    const response = yield call(searchProformaInvoiceItemAPI, payload);
    yield put(proformaInvoiceItemSearchSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceItemSearchFailure(error));
  }
}

function* watchProformaInvoiceItemSearch() {
  yield takeEvery(PROFORMA_INVOICE_ITEM_SEARCH, proformaInvoiceItemSearch);
}

// Proforma Invoice Status List
function* proformaInvoiceStatusList() {
  try {
    const response = yield call(getProformaInvoiceStatusListAPI);
    yield put(proformaInvoiceStatusListSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceStatusListFailure(error));
  }
}

function* watchProformaInvoiceStatusList() {
  yield takeEvery(PROFORMA_INVOICE_STATUS_LIST, proformaInvoiceStatusList);
}

// Proforma Invoice Status Data
function* proformaInvoiceStatusData({ payload }) {
  try {
    const response = yield call(getProformaInvoiceStatusDataAPI, payload);
    yield put(proformaInvoiceStatusDataSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceStatusDataFailure(error));
  }
}

function* watchProformaInvoiceStatusData() {
  yield takeEvery(PROFORMA_INVOICE_STATUS_DATA, proformaInvoiceStatusData);
}

// Proforma Invoice Status Create
function* proformaInvoiceStatusCreate({ payload }) {
  try {
    const response = yield call(createProformaInvoiceStatusAPI, payload);
    yield put(proformaInvoiceStatusCreateSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceStatusCreateFailure(error));
  }
}

function* watchProformaInvoiceStatusCreate() {
  yield takeEvery(PROFORMA_INVOICE_STATUS_CREATE, proformaInvoiceStatusCreate);
}

// Proforma Invoice Status Update
function* proformaInvoiceStatusUpdate({ payload }) {
  try {
    const response = yield call(updateProformaInvoiceStatusAPI, payload);
    console.log("response", response);
    yield put(proformaInvoiceStatusUpdateSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceStatusUpdateFailure(error));
  }
}

function* watchProformaInvoiceStatusUpdate() {
  yield takeEvery(PROFORMA_INVOICE_STATUS_UPDATE, proformaInvoiceStatusUpdate);
}

// Proforma Invoice Status Delete
function* proformaInvoiceStatusDelete({ payload }) {
  try {
    const response = yield call(deleteProformaInvoiceStatusAPI, payload);
    yield put(proformaInvoiceStatusDeleteSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceStatusDeleteFailure(error));
  }
}

function* watchProformaInvoiceStatusDelete() {
  yield takeEvery(PROFORMA_INVOICE_STATUS_DELETE, proformaInvoiceStatusDelete);
}

// Proforma Invoice PDF
function* proformaInvoicePDF({ payload }) {
  try {
    const response = yield call(getProformaInvoicePDFAPI, payload);
    yield put(proformaInvoicePDFSuccess(response));
  } catch (error) {
    yield put(proformaInvoicePDFFailure(error));
  }
}

function* watchProformaInvoicePDF() {
  yield takeEvery(PROFORMA_INVOICE_PDF, proformaInvoicePDF);
}

// Proforma Invoice Email Send Automated
function* proformaInvoiceEmailSendAutomated({ payload }) {
  try {
    const response = yield call(sendAutomatedProformaInvoiceEmailAPI, payload);
    yield put(proformaInvoiceEmailSendAutomatedSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceEmailSendAutomatedFailure(error));
  }
}

function* watchProformaInvoiceEmailSendAutomated() {
  yield takeEvery(
    PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED,
    proformaInvoiceEmailSendAutomated
  );
}

// Proforma Invoice Email Resend Automated
function* proformaInvoiceEmailResendAutomated({ payload }) {
  try {
    const response = yield call(
      resendAutomatedProformaInvoiceEmailAPI,
      payload
    );
    yield put(proformaInvoiceEmailResendAutomatedSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceEmailResendAutomatedFailure(error));
  }
}

function* watchProformaInvoiceEmailResendAutomated() {
  yield takeEvery(
    PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED,
    proformaInvoiceEmailResendAutomated
  );
}

// Proforma Invoice Convert To Invoice
function* proformaInvoiceConvertToInvoice({ payload }) {
  try {
    const response = yield call(convertProformaInvoiceToInvoiceAPI, payload);
    yield put(proformaInvoiceConvertToInvoiceSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceConvertToInvoiceFailure(error));
  }
}

function* watchProformaInvoiceConvertToInvoice() {
  yield takeEvery(
    PROFORMA_INVOICE_CONVERT_TO_INVOICE,
    proformaInvoiceConvertToInvoice
  );
}

// Proforma Invoice Search
function* proformaInvoiceSearch({ payload }) {
  try {
    const response = yield call(searchProformaInvoiceAPI, payload);
    console.log("response", response);
    yield put(proformaInvoiceSearchSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceSearchFailure(error));
  }
}

function* watchProformaInvoiceSearch() {
  yield takeEvery(PROFORMA_INVOICE_SEARCH, proformaInvoiceSearch);
}

// Proforma Invoice Activity Log Search
function* proformaInvoiceActivityLogSearch({ payload }) {
  try {
    const response = yield call(getProformaInvoiceActivityLogAPI, payload);
    yield put(proformaInvoiceActivityLogSearchSuccess(response));
  } catch (error) {
    yield put(proformaInvoiceActivityLogSearchFailure(error));
  }
}
function* watchProformaInvoiceActivityLogSearch() {
  yield takeEvery(
    PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH,
    proformaInvoiceActivityLogSearch
  );
}

export default function* ProformaInvoice() {
  yield all([
    fork(watchProformaInvoiceList),
    fork(watchProformaInvoiceListSearch),
    fork(watchProformaInvoiceData),
    fork(watchProformaInvoiceCreate),
    fork(watchProformaInvoiceUpdate),
    fork(watchProformaInvoiceVoid),
    fork(watchProformaInvoiceItemList),
    fork(watchProformaInvoiceItemSearch),
    fork(watchProformaInvoiceStatusList),
    fork(watchProformaInvoiceStatusData),
    fork(watchProformaInvoiceStatusCreate),
    fork(watchProformaInvoiceStatusUpdate),
    fork(watchProformaInvoiceStatusDelete),
    fork(watchProformaInvoicePDF),
    fork(watchProformaInvoiceEmailSendAutomated),
    fork(watchProformaInvoiceEmailResendAutomated),
    fork(watchProformaInvoiceConvertToInvoice),
    fork(watchProformaInvoiceSearch),
    fork(watchProformaInvoiceActivityLogSearch),
  ]);
}
